import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

// Для поддержки Buffer в браузере
window.Buffer = window.Buffer || require('buffer').Buffer;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);